/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
// import vaultsConfig from 'config/constants/vaults'
import { ApiServicesState, PricePerfullShareHistory } from '../types'
import fetchPricePerfullSharesHistoryData from './fetchPublicApiData'

export const registerPricePerfullShareData = async (token, walletAddress, vaultsAddress, pricePerfullShare) => {
  const response = await fetch(`${process.env.REACT_APP_API}/earns/regiserPricePerfullShare`, {
    method: 'POST',
    body: JSON.stringify({
      "walletAddress": walletAddress,
      "vaultsAddress": vaultsAddress,
      "pricePerFullShare": pricePerfullShare
    }),
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  })
  const result = await response.json();
  return result;
};

// const noAccountPricePerfullConfig = vaultsConfig.map((vault) => ({
//     vid: vault.vid,
//     name: vault.name,
//     contractAddress: vault.contractAddress,
//     lp: vault.lp,
//     pricePerFullShare: 0
//   }))
  
const initialState: ApiServicesState = {
  pricePerfullSharesHistory: {
    data: [],
    dataLoaded: false
  }
}

export const fetchPublicDataFromApi = (): any => async (dispatch) => {
  const data = await fetchPricePerfullSharesHistoryData()
  dispatch(setPricePerfullShareData(data))
}

// export const fetchUserDataFromApi =
//   (account: string): any =>
//   async (dispatch) => {
//     const pricePerfullShareData = await fetchPricePerfullShareData(account)
//     dispatch(setPricePerfullShareData(pricePerfullShareData))
//   }


export const apiServices = createSlice({
  name: 'apiServices',
  initialState,
  reducers: {
    setPricePerfullShareData: (state, action) => {
        const data: PricePerfullShareHistory[] = action.payload
        state.pricePerfullSharesHistory.data = data
        state.pricePerfullSharesHistory.dataLoaded = true
    },
    // updateIndividualPricePerfullShare:  (state, action) => {
    //     const livePricePerfullData = action.payload
    //     // @ts-ignore
    //     state.pricePerfullShare.data = state.pricePerfullShare.data.map((vault) => {
    //         if (vault.vid === livePricePerfullData.vid) {
    //             return { ...vault, ...livePricePerfullData }
    //         }
    //         return { vault }
    //     })
    // },
  },
})

// Actions
export const { setPricePerfullShareData } = apiServices.actions

export default apiServices.reducer
